<div class="box_default box_white custom_form fill-form" [ngClass]="{'with-overlay': modalView !== MODAL_VIEW_NONE}">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView === MODAL_VIEW_SUBMIT_ERROR"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'Something went wrong saving this form. Please review your data or reload the form and try again. If the error persists, please reach out to our support team through the Help Me button.'"
        [buttonText]="'OK'"
        (action)="onError($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView === MODAL_VIEW_FIELD_VALIDATION_ERROR"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'There are some invalid field values. Please review your form data try and try to save it again.'"
        [buttonText]="'OK'"
        (action)="onErrorFields($event)">
    </core-layout-modal-feedback>
    <div class="loader" *ngIf="loadingFields$ | async; else dataContent">
        <div class="dimmed_outset">
            <div class="dimmed_line">
            </div>
        </div>
        <div class="dimmed">
            <div class="dimmed_title"></div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
            </div>
            <div class="dimmed_title"></div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
            </div>
        </div>
    </div>
    <!--  After loading check length of forms or manage if errors or empty -->
    <ng-template #dataContent>
        <div class="box_main" *ngIf="(fields$ | async)?.length > 0 && dynamicLinKButtoncontext; else handleEmptyOrError">
            <form [formGroup]="form">
                <div class="form-specifications form-fill">
                    <div class="form-fields">
                        <ul class="fields-list">
                            <!-- place in the li the new component for form  dynamic fields where each field will be loaded in html -->
                             <!-- place a class to notify user validation had an error in submit -->
                            <li class="fields-list-item" 
                                [ngClass]="{'field-validation-error': hasFieldError(fieldSubmission.field.alias)}"
                                *ngFor="let fieldSubmission of (fields$ | async | sortBy : 'fieldSubmission.field.position' : 'asc') ">
                                <!-- (fieldValueChange)="onFieldChange($event)"-->
                                <custom-forms-dynamic-fill-field-host 
                                    [fieldSubmission]="fieldSubmission"
                                    [dynamicLinKButtoncontext] = "fieldSubmission.field.type === DYNAMIC_LINK_FIELD_TYPE ? dynamicLinKButtoncontext : null"
                                    [dynamicFieldValues]="fieldSubmission.field.type === DYNAMIC_FIELD_TYPE ? dynamicFieldAssociations[fieldSubmission.field.uuid] : []"
                                    (fieldValueChange)="onFieldValueChange($event)"
                                    (fieldValidityChange)="onFieldValidityChange($event)"
                                ></custom-forms-dynamic-fill-field-host>
                            </li>
                        </ul>
                    </div>
                    <div class="box_fieldset">
                        <core-helpers-forms-button-white [disabled]="buttonDisabled || !allFieldsReady"
                            [text]="saveBtntext" (click)="onSubmit()"></core-helpers-forms-button-white>
                        <core-helpers-forms-button [type]="'grey'" 
                            [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
                    </div>
                </div>
            </form>
        </div>
        <!-- Template for handling both no data and errors -->
        <ng-template #handleEmptyOrError>
            <div class="custom-forms-errors" *ngIf="errorFields$ | async as error; else emptyList">
                <div [ngSwitch]="error.status">
                    <!-- TO REVIEW ng17 when ngSwitch check values directly due to strict comparison -->
                    <!-- Error handling for each status -->
                    <div *ngSwitchCase="404" class="error">
                        <core-helpers-box-http-error [code]="404"
                            [message]="'Not found. Check your URL.'"></core-helpers-box-http-error>
                    </div>
                    <div *ngSwitchCase="403" class="error">
                        <core-helpers-box-http-error [code]="403" [message]="'Not allowed.'"></core-helpers-box-http-error>
                    </div>
                    <div *ngSwitchCase="500" class="error">
                        <core-helpers-box-http-error [code]="500"
                            [message]="'Internal server error, please refresh your browser. If the error persists, please reach out to our support team through the Help Me button.'"></core-helpers-box-http-error>
                    </div>
                    <div *ngSwitchDefault class="error">
                        <core-helpers-box-http-error [code]="''"
                            [message]="'Internal server error, please refresh your browser. If the error persists, please reach out to our support team through the Help Me button.'"></core-helpers-box-http-error>
                    </div>
                </div>
            </div>

            <ng-template #emptyList>
                <article class="forms-not-content">
                    <core-helpers-box-alert-message-icon [text]="'This form has no fields.'"
                        [icon]="'no_messages'"></core-helpers-box-alert-message-icon>
                </article>
            </ng-template>
        </ng-template>
    </ng-template>
</div>